/**
 * Slippage Price Calculation
 *
 * Calculates the limit price with slippage applied for IOC market orders.
 * Buy orders get a higher price, sell orders get a lower price.
 */

/**
 * Calculate slippage-adjusted price for market orders.
 *
 * @param marketPrice - Current market price as string
 * @param side - Order side: "buy" or "sell"
 * @param slippagePercent - Slippage as a percentage (e.g., 3 for 3%)
 * @returns Formatted price string with appropriate decimal precision
 */
export function calculateSlippagePrice(
  marketPrice: string,
  side: "buy" | "sell",
  slippagePercent: number,
): string {
  const price = Number(marketPrice);
  const slippageDecimal = slippagePercent / 100;

  const rawPrice =
    side === "buy"
      ? price * (1 + slippageDecimal)
      : price * (1 - slippageDecimal);

  // Format based on magnitude for appropriate tick size
  if (rawPrice >= 1000) return Math.round(rawPrice).toString();
  if (rawPrice >= 10) return rawPrice.toFixed(1);
  if (rawPrice >= 1) return rawPrice.toFixed(2);
  return rawPrice.toFixed(4);
}
